import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

const main = {
  height: {
    iphone: 50,
  },
};

export const SingleItemNavigationStyle = styled.div`
  border-radius: 8px;
  display: flex;
  flex-wrap: nowrap;
  min-height: ${main.height.iphone}px;
  overflow: hidden;
  position: relative;
  width: 100%;

  &.light-theme {
    background-color: ${colors.mostlyWhite};

    .single-item-navigation-previous,
    .single-item-navigation-next {
      border: solid 1px ${colors.mostlyWhite};
      color: ${colors.veryDarkGrayishBlue};

      svg {
        fill: ${colors.veryDarkGrayishBlue};
      }
    }

    .single-item-navigation-value {
      background-color: ${colors.mostlyWhite};
      color: ${colors.veryDarkGrayishBlue};
    }
  }

  &.dark-theme,
  &.default-theme {
    background-color: ${colors.veryDarkGrayishBlue};

    .single-item-navigation-previous,
    .single-item-navigation-next {
      border: solid 1px ${colors.veryDarkGrayishBlue};
      color: ${colors.mostlyWhite};

      svg {
        fill: ${colors.mostlyWhite};
      }
    }

    .single-item-navigation-value {
      background-color: ${colors.mostlyBlack};
      color: ${colors.mostlyWhite};
    }
  }

  &.soft-blue-outline-theme {
    background-color: ${colors.white};
    color: ${colors.softBlue};

    .single-item-navigation-previous,
    .single-item-navigation-next {
      border: solid 1px ${colors.softBlue};
      color: ${colors.softBlue};

      svg {
        fill: ${colors.softBlue};
      }
    }

    .single-item-navigation-value {
      background-color: ${colors.white};
      color: ${colors.softBlue};
    }
  }

  &.grayish-blue-outline-theme {
    background-color: ${colors.white};

    .single-item-navigation-previous,
    .single-item-navigation-next {
      border: solid 1px ${colors.grayishBlue};
      color: ${colors.grayishBlue};

      svg {
        fill: ${colors.grayishBlue};
      }
    }

    .single-item-navigation-value {
      background-color: ${colors.white};
      color: ${colors.grayishBlue};
    }
  }

  &.rounded-shape {
    border-radius: 8px;
  }

  &.circle-shape {
    border-radius: ${main.height.iphone / 2}px;
  }

  &.square-shape {
    border-radius: 0;
  }

  .single-item-navigation-previous,
  .single-item-navigation-next {
    display: block;
    height: ${main.height.iphone}px;
    max-width: ${main.height.iphone}px;
    min-width: ${main.height.iphone}px;
    position: relative;

    svg {
      display: block;
      height: 10px;
      left: 50%;
      position: absolute;
      top: 50%;
      width: 10px;
    }
  }

  .single-item-navigation-previous {
    svg {
      transform: translate(-50%, -50%) rotate(-90deg);
    }
  }

  .single-item-navigation-next {
    svg {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }

  .single-item-navigation-value {
    ${fontFamily.sourceSansPro.bold};
    font-size: 18px;
    line-height: 18px;
    max-width: calc(100% - (${main.height.iphone * 2}px));
    min-width: calc(100% - (${main.height.iphone * 2}px));
    padding: 16px 12px;
    text-align: center;
  }
`;
